export default __webpack_public_path__ + "static/media/Logo-Agrosur.763fb908.png";